import React from 'react'

import { useServiceOrder } from '../_load/ServiceOrderLoader'
import { useChildrenServiceOrders } from '../_load/ChildrenServiceOrdersLoader'
import DiagnosticoDeSegurancaContent from '../pages/DiagnosticoDeSeguranca/DiagnosticoDeSegurancaContent'
import ResumoEstrategicoContent from '../pages/ResumoEstrategico/ResumoEstrategicoContent'
import CalculoDeRiscoContent from '../pages/CalculoDeRisco/CalculoDeRiscoContent'
import { appendIf } from '@btime/helpers'
import {
  calcExtraValues,
  calcReplyValue,
  calcResult,
  findReplyByQuestionId,
  getDate,
  separateByCategoryId,
  sortAndReturnSelectedMoslerReplies,
  sortAndReturnSelectedReplies,
  splitPlaceResume,
  sumMaxValueByQuestionId,
  sumMaxValues,
  sumMinValueByQuestionId,
  sumMinValues,
  sumTotalValues,
  sumValueByQuestionId
} from '../_helpers/pdfHelpers'
import Separator from '../../../../components/helpers/Separator'
import ChassiPlataformaContent from '../pages/ChassiPlataforma/ChassiPlataformaContent'

const Content = () => {
  const serviceOrder = useServiceOrder()
  const childrenServiceOrders = useChildrenServiceOrders()

  const allServiceOrders = [serviceOrder, ...childrenServiceOrders]

  const resumoEstrategicoServiceOrder = allServiceOrders.find(so => so.checklist.id === 4)
  const dadosGeraisServiceOrder = allServiceOrders.find(so => so.checklist.id === 8)
  const andaresInternosServiceOrder = allServiceOrders.filter(so => so.checklist.id === 7)
  const recepcoesServiceOrder = allServiceOrders.filter(so => so.checklist.id === 9)
  const hallElevSSServiceOrder = allServiceOrders.filter(so => so.checklist.id === 10)
  const sistemasGeraisSServiceOrder = allServiceOrders.filter(so => so.checklist.id === 11)
  const moslerServiceOrder = allServiceOrders.find(so => so.checklist.id === 12)

  const resumoLocal = splitPlaceResume(serviceOrder?.place?.resume)

  const dadosGeraisReplies = dadosGeraisServiceOrder?.replies

  const emitente = findReplyByQuestionId(dadosGeraisReplies, 1375)?.value
  const codigo = findReplyByQuestionId(dadosGeraisReplies, 1376)?.value
  const dataEmissao = getDate(findReplyByQuestionId(dadosGeraisReplies, 1377)?.value)
  const classificacao = findReplyByQuestionId(dadosGeraisReplies, 1378)?.value
  const consultor = dadosGeraisServiceOrder?.user?.name
  const entrevistados = findReplyByQuestionId(dadosGeraisReplies, 1381)?.value
  const local = `${serviceOrder?.place?.name} ${resumoLocal?.complex ? '-' + resumoLocal?.complex : ''}`
  const endereco = serviceOrder?.place?.fieldValues.find(item => item.field.type === 'address')?.value?.search
  const dataAvaliacao = getDate(findReplyByQuestionId(dadosGeraisReplies, 1382)?.value)

  let headerValues = {
    emitente,
    codigo,
    dataEmissao,
    classificacao,
    local,
    endereco,
    consultor,
    entrevistados,
    dataAvaliacao
  }

  const andaresInternos = andaresInternosServiceOrder.map(item => {
    const replies = [...item.replies]

    const sortedReplies = sortAndReturnSelectedReplies(replies)
    const categorizedReplies = separateByCategoryId(sortedReplies)

    const floorsReply = findReplyByQuestionId(item.replies, 985)?.value
    const floors = floorsReply ? ` - ${floorsReply}` : ''

    const MPEMaxValues = sumMaxValues(categorizedReplies.medidasProtecaoEletronica)
    const MPHMaxValues = sumMaxValues(categorizedReplies.medidasProtecaoHumana)
    const MPFMaxValues = sumMaxValues(categorizedReplies.medidasProtecaoFisica)
    const MPOMaxValues = sumMaxValues(categorizedReplies.medidasProtecaoOrganizativa)

    const MPEMinValues = sumMinValues(categorizedReplies.medidasProtecaoEletronica)
    const MPHMinValues = sumMinValues(categorizedReplies.medidasProtecaoHumana)
    const MPFMinValues = sumMinValues(categorizedReplies.medidasProtecaoFisica)
    const MPOMinValues = sumMinValues(categorizedReplies.medidasProtecaoOrganizativa)

    const MPETotalValues = sumTotalValues(categorizedReplies.medidasProtecaoEletronica)
    const MPHTotalValues = sumTotalValues(categorizedReplies.medidasProtecaoHumana)
    const MPFTotalValues = sumTotalValues(categorizedReplies.medidasProtecaoFisica)
    const MPOTotalValues = sumTotalValues(categorizedReplies.medidasProtecaoOrganizativa)

    const MPEReplyValue = calcReplyValue(MPEMinValues, MPEMaxValues, MPETotalValues)
    const MPHReplyValue = calcReplyValue(MPHMinValues, MPHMaxValues, MPHTotalValues)
    const MPFReplyValue = calcReplyValue(MPFMinValues, MPFMaxValues, MPFTotalValues)
    const MPOReplyValue = calcReplyValue(MPOMinValues, MPOMaxValues, MPOTotalValues)

    const MPEResult = calcResult(MPEReplyValue)
    const MPHResult = calcResult(MPHReplyValue)
    const MPFResult = calcResult(MPFReplyValue)
    const MPOResult = calcResult(MPOReplyValue)

    const grauProtecao = parseFloat(((MPEResult + MPHResult + MPFResult + MPOResult) / 4).toFixed(2))
    const grauVulnerabilidade = parseFloat((99.8 - grauProtecao).toFixed(2))

    const allCategories = [
      ...categorizedReplies.medidasProtecaoEletronica,
      ...categorizedReplies.medidasProtecaoHumana,
      ...categorizedReplies.medidasProtecaoFisica,
      ...categorizedReplies.medidasProtecaoOrganizativa
    ]

    const CAQuestions = [
      2997, 2999, 3001, 3003, 3005, 3007, 3009, 3011, 3025, 3041, 3043, 3045, 3047, 3049, 3051, 3057, 3059, 3065, 3067,
      3069
    ]
    const CTVQuestion = [2989, 2991, 2993, 2995, 3021]
    const InfraQuestions = [3005, 3007, 3009, 3011, 3021, 3051, 3057, 3059, 3061, 3065]
    const EMQuestions = [
      3013, 3015, 3017, 3019, 3021, 3023, 3027, 3029, 3031, 3037, 3039, 3053, 3055, 3063, 3071, 3073, 3075, 3077, 3079,
      3091, 3099, 3101, 3103, 3105, 3107, 3109, 3111, 3113
    ]
    const SIQuestions = [3013, 3015, 3037, 3053, 3055, 3075, 3077, 3091, 3103]
    const DLQuestions = [3029, 3031, 3035, 3037, 3081, 3089, 3091, 3093, 3095, 3097, 3111, 3113]
    const AEQuestions = [3017, 3027, 3029, 3039, 3073, 3079, 3091, 3097, 3113]
    const PCQuestions = [3041, 3067, 3069, 3071, 3081, 3083, 3085, 3087, 3089, 3093]

    const sumMinControlAccessValue = sumMinValueByQuestionId(allCategories, CAQuestions)
    const sumMinCircuitTVValue = sumMinValueByQuestionId(allCategories, CTVQuestion)
    const sumMinInfraValue = sumMinValueByQuestionId(allCategories, InfraQuestions)
    const sumMinMedicalEmergencyValue = sumMinValueByQuestionId(allCategories, EMQuestions)
    const sumMinFireSystemValue = sumMinValueByQuestionId(allCategories, SIQuestions)
    const sumMinLegalDemandValue = sumMinValueByQuestionId(allCategories, DLQuestions)
    const sumMinEmergencyPlansValue = sumMinValueByQuestionId(allCategories, AEQuestions)
    const sumMinProcedureValue = sumMinValueByQuestionId(allCategories, PCQuestions)

    const sumControlAccessValue = sumValueByQuestionId(allCategories, CAQuestions)
    const sumCircuitTVValue = sumValueByQuestionId(allCategories, CTVQuestion)
    const sumInfraValue = sumValueByQuestionId(allCategories, InfraQuestions)
    const sumMedicalEmergencyValue = sumValueByQuestionId(allCategories, EMQuestions)
    const sumFireSystemValue = sumValueByQuestionId(allCategories, SIQuestions)
    const sumLegalDemandValue = sumValueByQuestionId(allCategories, DLQuestions)
    const sumEmergencyPlansValue = sumValueByQuestionId(allCategories, AEQuestions)
    const sumProcedureValue = sumValueByQuestionId(allCategories, PCQuestions)

    const sumMaxControlAccessValue = sumMaxValueByQuestionId(allCategories, CAQuestions)
    const sumMaxCircuitTVValue = sumMaxValueByQuestionId(allCategories, CTVQuestion)
    const sumMaxInfraValue = sumMaxValueByQuestionId(allCategories, InfraQuestions)
    const sumMaxMedicalEmergencyValue = sumMaxValueByQuestionId(allCategories, EMQuestions)
    const sumMaxFireSystemValue = sumMaxValueByQuestionId(allCategories, SIQuestions)
    const sumMaxLegalDemandValue = sumMaxValueByQuestionId(allCategories, DLQuestions)
    const sumMaxEmergencyPlansValue = sumMaxValueByQuestionId(allCategories, AEQuestions)
    const sumMaxProcedureValue = sumMaxValueByQuestionId(allCategories, PCQuestions)

    const controlAccess = calcExtraValues(sumMinControlAccessValue, sumControlAccessValue, sumMaxControlAccessValue)
    const circuitTV = calcExtraValues(sumMinCircuitTVValue, sumCircuitTVValue, sumMaxCircuitTVValue)
    const infra = calcExtraValues(sumMinInfraValue, sumInfraValue, sumMaxInfraValue)
    const medicalEmergency = calcExtraValues(
      sumMinMedicalEmergencyValue,
      sumMedicalEmergencyValue,
      sumMaxMedicalEmergencyValue
    )
    const fireSystem = calcExtraValues(sumMinFireSystemValue, sumFireSystemValue, sumMaxFireSystemValue)
    const legalDemand = calcExtraValues(sumMinLegalDemandValue, sumLegalDemandValue, sumMaxLegalDemandValue)
    const emergencyPlans = calcExtraValues(sumMinEmergencyPlansValue, sumEmergencyPlansValue, sumMaxEmergencyPlansValue)
    const procedure = calcExtraValues(sumMinProcedureValue, sumProcedureValue, sumMaxProcedureValue)

    return {
      type: 'andaresInternos',
      category: `CATEGORIA: ANDARES INTERNO PRIVADO${floors}`,
      title: `ANDARES INTERNO PRIVADO`,
      floors: floors,
      local,
      medidasProtecaoEletronica: {
        label: 'Proteção Eletronica',
        replies: categorizedReplies.medidasProtecaoEletronica || [],
        totalMaxValue: MPEMaxValues,
        totalMinValueTotal: MPEMinValues,
        totalValue: MPETotalValues,
        replyValue: MPEReplyValue,
        result: MPEResult
      },
      medidasProtecaoHumana: {
        label: 'Proteção Humana',
        replies: categorizedReplies.medidasProtecaoHumana || [],
        totalMaxValue: MPHMaxValues,
        totalMinValueTotal: MPHMinValues,
        totalValue: MPHTotalValues,
        replyValue: MPHReplyValue,
        result: MPHResult
      },
      medidasProtecaoFisica: {
        label: 'Proteção Física',
        replies: categorizedReplies.medidasProtecaoFisica || [],
        totalMaxValue: MPFMaxValues,
        totalMinValueTotal: MPFMinValues,
        totalValue: MPFTotalValues,
        replyValue: MPFReplyValue,
        result: MPFResult
      },
      medidasProtecaoOrganizativa: {
        label: 'Proteção Organizativa',
        replies: categorizedReplies.medidasProtecaoOrganizativa || [],
        totalMaxValue: MPOMaxValues,
        totalMinValueTotal: MPOMinValues,
        totalValue: MPOTotalValues,
        replyValue: MPOReplyValue,
        result: MPOResult
      },
      grauProtecao,
      grauVulnerabilidade,
      controlAccess,
      circuitTV,
      infra,
      medicalEmergency,
      fireSystem,
      legalDemand,
      emergencyPlans,
      procedure
    }
  })

  const recepcoes = recepcoesServiceOrder.map(item => {
    const replies = [...item.replies]

    const sortedReplies = sortAndReturnSelectedReplies(replies)
    const categorizedReplies = separateByCategoryId(sortedReplies)

    const floorsReply = findReplyByQuestionId(item.replies, 3115)?.value
    const floors = floorsReply ? ` - ${floorsReply}` : ''

    const MPEMaxValues = sumMaxValues(categorizedReplies.medidasProtecaoEletronica)
    const MPHMaxValues = sumMaxValues(categorizedReplies.medidasProtecaoHumana)
    const MPFMaxValues = sumMaxValues(categorizedReplies.medidasProtecaoFisica)
    const MPOMaxValues = sumMaxValues(categorizedReplies.medidasProtecaoOrganizativa)

    const MPEMinValues = sumMinValues(categorizedReplies.medidasProtecaoEletronica)
    const MPHMinValues = sumMinValues(categorizedReplies.medidasProtecaoHumana)
    const MPFMinValues = sumMinValues(categorizedReplies.medidasProtecaoFisica)
    const MPOMinValues = sumMinValues(categorizedReplies.medidasProtecaoOrganizativa)

    const MPETotalValues = sumTotalValues(categorizedReplies.medidasProtecaoEletronica)
    const MPHTotalValues = sumTotalValues(categorizedReplies.medidasProtecaoHumana)
    const MPFTotalValues = sumTotalValues(categorizedReplies.medidasProtecaoFisica)
    const MPOTotalValues = sumTotalValues(categorizedReplies.medidasProtecaoOrganizativa)

    const MPEReplyValue = calcReplyValue(MPEMinValues, MPEMaxValues, MPETotalValues)
    const MPHReplyValue = calcReplyValue(MPHMinValues, MPHMaxValues, MPHTotalValues)
    const MPFReplyValue = calcReplyValue(MPFMinValues, MPFMaxValues, MPFTotalValues)
    const MPOReplyValue = calcReplyValue(MPOMinValues, MPOMaxValues, MPOTotalValues)

    const MPEResult = calcResult(MPEReplyValue)
    const MPHResult = calcResult(MPHReplyValue)
    const MPFResult = calcResult(MPFReplyValue)
    const MPOResult = calcResult(MPOReplyValue)

    const grauProtecao = parseFloat(((MPEResult + MPHResult + MPFResult + MPOResult) / 4).toFixed(2))
    const grauVulnerabilidade = parseFloat((99.8 - grauProtecao).toFixed(2))

    const allCategories = [
      ...categorizedReplies.medidasProtecaoEletronica,
      ...categorizedReplies.medidasProtecaoHumana,
      ...categorizedReplies.medidasProtecaoFisica,
      ...categorizedReplies.medidasProtecaoOrganizativa
    ]

    const CAQuestions = [
      3118, 3120, 3126, 3128, 3130, 3132, 3134, 3142, 3144, 3164, 3166, 1970, 1972, 1976, 3168, 3170, 3172, 3174, 3178,
      3180, 3182, 3184, 3186, 3190, 3192, 3194, 3196, 3198, 3200, 3202, 3206, 3208, 3210, 3212, 3214, 3216, 3218, 3220,
      3226, 3228
    ]
    const CTVQuestion = [3122, 3124]
    const InfraQuestions = [3146, 3162]
    const EMQuestions = [3116, 3136, 3148, 3150, 3152, 3154, 3156, 3158, 1974, 3222, 3224]
    const SIQuestions = [3138, 3140, 3148]
    const DLQuestions = [3128, 3140, 3146, 3148, 3172, 3196, 3200]
    const AEQuestions = [3188, 3196, 3224]
    const PCQuestions = [3188, 3190, 3196, 3198, 3206, 3208, 3210, 3212, 3214, 3226, 3228]

    const sumMinControlAccessValue = sumMinValueByQuestionId(allCategories, CAQuestions)
    const sumMinCircuitTVValue = sumMinValueByQuestionId(allCategories, CTVQuestion)
    const sumMinInfraValue = sumMinValueByQuestionId(allCategories, InfraQuestions)
    const sumMinMedicalEmergencyValue = sumMinValueByQuestionId(allCategories, EMQuestions)
    const sumMinFireSystemValue = sumMinValueByQuestionId(allCategories, SIQuestions)
    const sumMinLegalDemandValue = sumMinValueByQuestionId(allCategories, DLQuestions)
    const sumMinEmergencyPlansValue = sumMinValueByQuestionId(allCategories, AEQuestions)
    const sumMinProcedureValue = sumMinValueByQuestionId(allCategories, PCQuestions)

    const sumControlAccessValue = sumValueByQuestionId(allCategories, CAQuestions)
    const sumCircuitTVValue = sumValueByQuestionId(allCategories, CTVQuestion)
    const sumInfraValue = sumValueByQuestionId(allCategories, InfraQuestions)
    const sumMedicalEmergencyValue = sumValueByQuestionId(allCategories, EMQuestions)
    const sumFireSystemValue = sumValueByQuestionId(allCategories, SIQuestions)
    const sumLegalDemandValue = sumValueByQuestionId(allCategories, DLQuestions)
    const sumEmergencyPlansValue = sumValueByQuestionId(allCategories, AEQuestions)
    const sumProcedureValue = sumValueByQuestionId(allCategories, PCQuestions)

    const sumMaxControlAccessValue = sumMaxValueByQuestionId(allCategories, CAQuestions)
    const sumMaxCircuitTVValue = sumMaxValueByQuestionId(allCategories, CTVQuestion)
    const sumMaxInfraValue = sumMaxValueByQuestionId(allCategories, InfraQuestions)
    const sumMaxMedicalEmergencyValue = sumMaxValueByQuestionId(allCategories, EMQuestions)
    const sumMaxFireSystemValue = sumMaxValueByQuestionId(allCategories, SIQuestions)
    const sumMaxLegalDemandValue = sumMaxValueByQuestionId(allCategories, DLQuestions)
    const sumMaxEmergencyPlansValue = sumMaxValueByQuestionId(allCategories, AEQuestions)
    const sumMaxProcedureValue = sumMaxValueByQuestionId(allCategories, PCQuestions)

    const controlAccess = calcExtraValues(sumMinControlAccessValue, sumControlAccessValue, sumMaxControlAccessValue)
    const circuitTV = calcExtraValues(sumMinCircuitTVValue, sumCircuitTVValue, sumMaxCircuitTVValue)
    const infra = calcExtraValues(sumMinInfraValue, sumInfraValue, sumMaxInfraValue)
    const medicalEmergency = calcExtraValues(
      sumMinMedicalEmergencyValue,
      sumMedicalEmergencyValue,
      sumMaxMedicalEmergencyValue
    )
    const fireSystem = calcExtraValues(sumMinFireSystemValue, sumFireSystemValue, sumMaxFireSystemValue)
    const legalDemand = calcExtraValues(sumMinLegalDemandValue, sumLegalDemandValue, sumMaxLegalDemandValue)
    const emergencyPlans = calcExtraValues(sumMinEmergencyPlansValue, sumEmergencyPlansValue, sumMaxEmergencyPlansValue)
    const procedure = calcExtraValues(sumMinProcedureValue, sumProcedureValue, sumMaxProcedureValue)

    return {
      type: 'recepcoes',
      category: `CATEGORIA: RECEPÇÕES${floors}`,
      title: `RECEPÇÕES`,
      floors: floors,
      local,
      medidasProtecaoEletronica: {
        label: 'Proteção Eletronica',
        replies: categorizedReplies.medidasProtecaoEletronica || [],
        totalMaxValue: MPEMaxValues,
        totalMinValueTotal: MPEMinValues,
        totalValue: MPETotalValues,
        replyValue: MPEReplyValue,
        result: MPEResult
      },
      medidasProtecaoHumana: {
        label: 'Proteção Humana',
        replies: categorizedReplies.medidasProtecaoHumana || [],
        totalMaxValue: MPHMaxValues,
        totalMinValueTotal: MPHMinValues,
        totalValue: MPHTotalValues,
        replyValue: MPHReplyValue,
        result: MPHResult
      },
      medidasProtecaoFisica: {
        label: 'Proteção Física',
        replies: categorizedReplies.medidasProtecaoFisica || [],
        totalMaxValue: MPFMaxValues,
        totalMinValueTotal: MPFMinValues,
        totalValue: MPFTotalValues,
        replyValue: MPFReplyValue,
        result: MPFResult
      },
      medidasProtecaoOrganizativa: {
        label: 'Proteção Organizativa',
        replies: categorizedReplies.medidasProtecaoOrganizativa || [],
        totalMaxValue: MPOMaxValues,
        totalMinValueTotal: MPOMinValues,
        totalValue: MPOTotalValues,
        replyValue: MPOReplyValue,
        result: MPOResult
      },
      grauProtecao,
      grauVulnerabilidade,
      controlAccess,
      circuitTV,
      infra,
      medicalEmergency,
      fireSystem,
      legalDemand,
      emergencyPlans,
      procedure
    }
  })

  const hallElevSS = hallElevSSServiceOrder.map(item => {
    const replies = [...item.replies]

    const sortedReplies = sortAndReturnSelectedReplies(replies)
    const categorizedReplies = separateByCategoryId(sortedReplies)

    const MPEMaxValues = sumMaxValues(categorizedReplies.medidasProtecaoEletronica)
    const MPHMaxValues = sumMaxValues(categorizedReplies.medidasProtecaoHumana)
    const MPFMaxValues = sumMaxValues(categorizedReplies.medidasProtecaoFisica)
    const MPOMaxValues = sumMaxValues(categorizedReplies.medidasProtecaoOrganizativa)

    const MPEMinValues = sumMinValues(categorizedReplies.medidasProtecaoEletronica)
    const MPHMinValues = sumMinValues(categorizedReplies.medidasProtecaoHumana)
    const MPFMinValues = sumMinValues(categorizedReplies.medidasProtecaoFisica)
    const MPOMinValues = sumMinValues(categorizedReplies.medidasProtecaoOrganizativa)

    const MPETotalValues = sumTotalValues(categorizedReplies.medidasProtecaoEletronica)
    const MPHTotalValues = sumTotalValues(categorizedReplies.medidasProtecaoHumana)
    const MPFTotalValues = sumTotalValues(categorizedReplies.medidasProtecaoFisica)
    const MPOTotalValues = sumTotalValues(categorizedReplies.medidasProtecaoOrganizativa)

    const MPEReplyValue = calcReplyValue(MPEMinValues, MPEMaxValues, MPETotalValues)
    const MPHReplyValue = calcReplyValue(MPHMinValues, MPHMaxValues, MPHTotalValues)
    const MPFReplyValue = calcReplyValue(MPFMinValues, MPFMaxValues, MPFTotalValues)
    const MPOReplyValue = calcReplyValue(MPOMinValues, MPOMaxValues, MPOTotalValues)

    const MPEResult = calcResult(MPEReplyValue)
    const MPHResult = calcResult(MPHReplyValue)
    const MPFResult = calcResult(MPFReplyValue)
    const MPOResult = calcResult(MPOReplyValue)

    const grauProtecao = parseFloat(((MPEResult + MPHResult + MPFResult + MPOResult) / 4).toFixed(2))
    const grauVulnerabilidade = parseFloat((99.8 - grauProtecao).toFixed(2))

    const allCategories = [
      ...categorizedReplies.medidasProtecaoEletronica,
      ...categorizedReplies.medidasProtecaoHumana,
      ...categorizedReplies.medidasProtecaoFisica,
      ...categorizedReplies.medidasProtecaoOrganizativa
    ]

    const CAQuestions = [2448, 2450, 3234, 3240]
    const CTVQuestion = [2444, 2446]
    const InfraQuestions = [2446, 3236, 3238]
    const EMQuestions = [3230, 3232, 3244]
    const SIQuestions = []
    const DLQuestions = []
    const AEQuestions = []
    const PCQuestions = [3242, 3244]

    const sumMinControlAccessValue = sumMinValueByQuestionId(allCategories, CAQuestions)
    const sumMinCircuitTVValue = sumMinValueByQuestionId(allCategories, CTVQuestion)
    const sumMinInfraValue = sumMinValueByQuestionId(allCategories, InfraQuestions)
    const sumMinMedicalEmergencyValue = sumMinValueByQuestionId(allCategories, EMQuestions)
    const sumMinFireSystemValue = sumMinValueByQuestionId(allCategories, SIQuestions)
    const sumMinLegalDemandValue = sumMinValueByQuestionId(allCategories, DLQuestions)
    const sumMinEmergencyPlansValue = sumMinValueByQuestionId(allCategories, AEQuestions)
    const sumMinProcedureValue = sumMinValueByQuestionId(allCategories, PCQuestions)

    const sumControlAccessValue = sumValueByQuestionId(allCategories, CAQuestions)
    const sumCircuitTVValue = sumValueByQuestionId(allCategories, CTVQuestion)
    const sumInfraValue = sumValueByQuestionId(allCategories, InfraQuestions)
    const sumMedicalEmergencyValue = sumValueByQuestionId(allCategories, EMQuestions)
    const sumFireSystemValue = sumValueByQuestionId(allCategories, SIQuestions)
    const sumLegalDemandValue = sumValueByQuestionId(allCategories, DLQuestions)
    const sumEmergencyPlansValue = sumValueByQuestionId(allCategories, AEQuestions)
    const sumProcedureValue = sumValueByQuestionId(allCategories, PCQuestions)

    const sumMaxControlAccessValue = sumMaxValueByQuestionId(allCategories, CAQuestions)
    const sumMaxCircuitTVValue = sumMaxValueByQuestionId(allCategories, CTVQuestion)
    const sumMaxInfraValue = sumMaxValueByQuestionId(allCategories, InfraQuestions)
    const sumMaxMedicalEmergencyValue = sumMaxValueByQuestionId(allCategories, EMQuestions)
    const sumMaxFireSystemValue = sumMaxValueByQuestionId(allCategories, SIQuestions)
    const sumMaxLegalDemandValue = sumMaxValueByQuestionId(allCategories, DLQuestions)
    const sumMaxEmergencyPlansValue = sumMaxValueByQuestionId(allCategories, AEQuestions)
    const sumMaxProcedureValue = sumMaxValueByQuestionId(allCategories, PCQuestions)

    const controlAccess = calcExtraValues(sumMinControlAccessValue, sumControlAccessValue, sumMaxControlAccessValue)
    const circuitTV = calcExtraValues(sumMinCircuitTVValue, sumCircuitTVValue, sumMaxCircuitTVValue)
    const infra = calcExtraValues(sumMinInfraValue, sumInfraValue, sumMaxInfraValue)
    const medicalEmergency = calcExtraValues(
      sumMinMedicalEmergencyValue,
      sumMedicalEmergencyValue,
      sumMaxMedicalEmergencyValue
    )
    const fireSystem = calcExtraValues(sumMinFireSystemValue, sumFireSystemValue, sumMaxFireSystemValue)
    const legalDemand = calcExtraValues(sumMinLegalDemandValue, sumLegalDemandValue, sumMaxLegalDemandValue)
    const emergencyPlans = calcExtraValues(sumMinEmergencyPlansValue, sumEmergencyPlansValue, sumMaxEmergencyPlansValue)
    const procedure = calcExtraValues(sumMinProcedureValue, sumProcedureValue, sumMaxProcedureValue)

    return {
      type: 'hallElevSS',
      category: `CATEGORIA: HALL, ELEVADORES E SUBSOLOS`,
      title: `HALL, ELEVADORES E SUBSOLOS`,
      local,
      medidasProtecaoEletronica: {
        label: 'Proteção Eletronica',
        replies: categorizedReplies.medidasProtecaoEletronica || [],
        totalMaxValue: MPEMaxValues,
        totalMinValueTotal: MPEMinValues,
        totalValue: MPETotalValues,
        replyValue: MPEReplyValue,
        result: MPEResult
      },
      medidasProtecaoHumana: {
        label: 'Proteção Humana',
        replies: categorizedReplies.medidasProtecaoHumana || [],
        totalMaxValue: MPHMaxValues,
        totalMinValueTotal: MPHMinValues,
        totalValue: MPHTotalValues,
        replyValue: MPHReplyValue,
        result: MPHResult
      },
      medidasProtecaoFisica: {
        label: 'Proteção Física',
        replies: categorizedReplies.medidasProtecaoFisica || [],
        totalMaxValue: MPFMaxValues,
        totalMinValueTotal: MPFMinValues,
        totalValue: MPFTotalValues,
        replyValue: MPFReplyValue,
        result: MPFResult
      },
      medidasProtecaoOrganizativa: {
        label: 'Proteção Organizativa',
        replies: categorizedReplies.medidasProtecaoOrganizativa || [],
        totalMaxValue: MPOMaxValues,
        totalMinValueTotal: MPOMinValues,
        totalValue: MPOTotalValues,
        replyValue: MPOReplyValue,
        result: MPOResult
      },
      grauProtecao,
      grauVulnerabilidade,
      controlAccess,
      circuitTV,
      infra,
      medicalEmergency,
      fireSystem,
      legalDemand,
      emergencyPlans,
      procedure
    }
  })

  const sistemaGerais = sistemasGeraisSServiceOrder.map(item => {
    const replies = [...item.replies]

    const sortedReplies = sortAndReturnSelectedReplies(replies)
    const categorizedReplies = separateByCategoryId(sortedReplies)

    const PCIMaxValues = sumMaxValues(categorizedReplies.prevencaoCombateIncendios)
    const PAEMMaxValues = sumMaxValues(categorizedReplies.processoAtendimentoEmergenciaMedica)
    const AMaxValues = sumMaxValues(categorizedReplies.acessibilidade)
    const HMaxValues = sumMaxValues(categorizedReplies.heliponto)

    const PCIMinValues = sumMinValues(categorizedReplies.prevencaoCombateIncendios)
    const PAEMMinValues = sumMinValues(categorizedReplies.processoAtendimentoEmergenciaMedica)
    const AMinValues = sumMinValues(categorizedReplies.acessibilidade)
    const HMinValues = sumMinValues(categorizedReplies.heliponto)

    const PCITotalValues = sumTotalValues(categorizedReplies.prevencaoCombateIncendios)
    const PAEMTotalValues = sumTotalValues(categorizedReplies.processoAtendimentoEmergenciaMedica)
    const ATotalValues = sumTotalValues(categorizedReplies.acessibilidade)
    const HTotalValues = sumTotalValues(categorizedReplies.heliponto)

    const PCIReplyValue = calcReplyValue(PCIMinValues, PCIMaxValues, PCITotalValues)
    const PAEMReplyValue = calcReplyValue(PAEMMinValues, PAEMMaxValues, PAEMTotalValues)
    const AReplyValue = calcReplyValue(AMinValues, AMaxValues, ATotalValues)
    const HReplyValue = calcReplyValue(HMinValues, HMaxValues, HTotalValues)

    const PCIResult = calcResult(PCIReplyValue)
    const PAEMResult = calcResult(PAEMReplyValue)
    const AResult = calcResult(AReplyValue)
    const HResult = calcResult(HReplyValue)

    const categories = [
      ...appendIf(PCIResult > 0, PCIResult),
      ...appendIf(PAEMResult > 0, PAEMResult),
      ...appendIf(AResult > 0, AResult),
      ...appendIf(HResult > 0, HResult)
    ]

    const allCategories = [
      ...appendIf(categorizedReplies.prevencaoCombateIncendios, categorizedReplies.prevencaoCombateIncendios),
      ...appendIf(
        categorizedReplies.processoAtendimentoEmergenciaMedica,
        categorizedReplies.processoAtendimentoEmergenciaMedica
      ),
      ...appendIf(categorizedReplies.acessibilidade, categorizedReplies.acessibilidade),
      ...appendIf(categorizedReplies.heliponto, categorizedReplies.heliponto)
    ]

    const flatCategories = allCategories.flatMap(item => item)

    const CAQuestions = []
    const CTVQuestion = []
    const InfraQuestions = [2873, 2879]
    const EMQuestions = [2877, 2879]
    const SIQuestions = [2873, 2879, 2893, 2899, 2901, 2905, 2913]
    const DLQuestions = [2875, 2893, 2895, 2897, 2899, 2901, 2903, 2905, 2913]
    const AEQuestions = [2875, 2877, 2881, 2903]
    const PCQuestions = [2887, 2889, 2891, 2893, 2895, 2897, 2907, 2909, 2911, 2913, 2915]

    const sumMinControlAccessValue = sumMinValueByQuestionId(flatCategories, CAQuestions)
    const sumMinCircuitTVValue = sumMinValueByQuestionId(flatCategories, CTVQuestion)
    const sumMinInfraValue = sumMinValueByQuestionId(flatCategories, InfraQuestions)
    const sumMinMedicalEmergencyValue = sumMinValueByQuestionId(flatCategories, EMQuestions)
    const sumMinFireSystemValue = sumMinValueByQuestionId(flatCategories, SIQuestions)
    const sumMinLegalDemandValue = sumMinValueByQuestionId(flatCategories, DLQuestions)
    const sumMinEmergencyPlansValue = sumMinValueByQuestionId(flatCategories, AEQuestions)
    const sumMinProcedureValue = sumMinValueByQuestionId(flatCategories, PCQuestions)

    const sumControlAccessValue = sumValueByQuestionId(flatCategories, CAQuestions)
    const sumCircuitTVValue = sumValueByQuestionId(flatCategories, CTVQuestion)
    const sumInfraValue = sumValueByQuestionId(flatCategories, InfraQuestions)
    const sumMedicalEmergencyValue = sumValueByQuestionId(flatCategories, EMQuestions)
    const sumFireSystemValue = sumValueByQuestionId(flatCategories, SIQuestions)
    const sumLegalDemandValue = sumValueByQuestionId(flatCategories, DLQuestions)
    const sumEmergencyPlansValue = sumValueByQuestionId(flatCategories, AEQuestions)
    const sumProcedureValue = sumValueByQuestionId(flatCategories, PCQuestions)

    const sumMaxControlAccessValue = sumMaxValueByQuestionId(flatCategories, CAQuestions)
    const sumMaxCircuitTVValue = sumMaxValueByQuestionId(flatCategories, CTVQuestion)
    const sumMaxInfraValue = sumMaxValueByQuestionId(flatCategories, InfraQuestions)
    const sumMaxMedicalEmergencyValue = sumMaxValueByQuestionId(flatCategories, EMQuestions)
    const sumMaxFireSystemValue = sumMaxValueByQuestionId(flatCategories, SIQuestions)
    const sumMaxLegalDemandValue = sumMaxValueByQuestionId(flatCategories, DLQuestions)
    const sumMaxEmergencyPlansValue = sumMaxValueByQuestionId(flatCategories, AEQuestions)
    const sumMaxProcedureValue = sumMaxValueByQuestionId(flatCategories, PCQuestions)

    const controlAccess = calcExtraValues(sumMinControlAccessValue, sumControlAccessValue, sumMaxControlAccessValue)
    const circuitTV = calcExtraValues(sumMinCircuitTVValue, sumCircuitTVValue, sumMaxCircuitTVValue)
    const infra = calcExtraValues(sumMinInfraValue, sumInfraValue, sumMaxInfraValue)
    const medicalEmergency = calcExtraValues(
      sumMinMedicalEmergencyValue,
      sumMedicalEmergencyValue,
      sumMaxMedicalEmergencyValue
    )
    const fireSystem = calcExtraValues(sumMinFireSystemValue, sumFireSystemValue, sumMaxFireSystemValue)
    const legalDemand = calcExtraValues(sumMinLegalDemandValue, sumLegalDemandValue, sumMaxLegalDemandValue)
    const emergencyPlans = calcExtraValues(sumMinEmergencyPlansValue, sumEmergencyPlansValue, sumMaxEmergencyPlansValue)
    const procedure = calcExtraValues(sumMinProcedureValue, sumProcedureValue, sumMaxProcedureValue)

    const grauProtecao = parseFloat(((PCIResult + AResult) / categories.length).toFixed(2))
    const grauVulnerabilidade = parseFloat((99.8 - grauProtecao).toFixed(2))

    return {
      type: 'sistemasGerais',
      category: `CATEGORIA: SISTEMAS GERAIS`,
      title: `SISTEMAS GERAIS`,
      local,
      prevencaoCombateIncendios: {
        label: 'Sistema de Prevenção e Combate a Incêndios',
        replies: categorizedReplies.prevencaoCombateIncendios || [],
        totalMaxValue: PCIMaxValues,
        totalMinValueTotal: PCIMinValues,
        totalValue: PCITotalValues,
        replyValue: PCIReplyValue,
        result: PCIResult
      },
      processoAtendimentoEmergenciaMedica: {
        label: 'Processo de Atendimento a Emergência Médica',
        replies: categorizedReplies.processoAtendimentoEmergenciaMedica || [],
        totalMaxValue: PAEMMaxValues,
        totalMinValueTotal: PAEMMinValues,
        totalValue: PAEMTotalValues,
        replyValue: PAEMReplyValue,
        result: PAEMResult
      },
      acessibilidade: {
        label: 'Acessibilidade',
        replies: categorizedReplies.acessibilidade || [],
        totalMaxValue: AMaxValues,
        totalMinValueTotal: AMinValues,
        totalValue: ATotalValues,
        replyValue: AReplyValue,
        result: AResult
      },
      heliponto: {
        label: 'Heliponto',
        replies: categorizedReplies.heliponto || [],
        totalMaxValue: HMaxValues,
        totalMinValueTotal: HMinValues,
        totalValue: HTotalValues,
        replyValue: HReplyValue,
        result: HResult
      },
      grauProtecao,
      grauVulnerabilidade,
      controlAccess,
      circuitTV,
      infra,
      medicalEmergency,
      fireSystem,
      legalDemand,
      emergencyPlans,
      procedure
    }
  })

  const diagSegValues = [...andaresInternos, ...recepcoes, ...hallElevSS, ...sistemaGerais]

  const moslerReplies = [...moslerServiceOrder?.replies]
  const moslerSortedReplies = sortAndReturnSelectedMoslerReplies(moslerReplies)
  const moslerValues = separateByCategoryId(moslerSortedReplies)

  return (
    <>
      <ChassiPlataformaContent headerValues={headerValues} moslerValues={moslerValues} diagSegValues={diagSegValues} />
      <Separator weight={10} />
      <DiagnosticoDeSegurancaContent headerValues={headerValues} diagSegValues={diagSegValues} />
      <Separator weight={10} />
      <CalculoDeRiscoContent headerValues={headerValues} diagSegValues={diagSegValues} moslerValues={moslerValues} />
      <Separator weight={10} />
      {resumoEstrategicoServiceOrder && <ResumoEstrategicoContent headerValues={headerValues} />}
    </>
  )
}

export default Content
